import {ControlsWelcomeRegisterRegisterControl} from "../../../../controls/Modules/WelcomeModule/RegisterPresenter/RegisterControl/RegisterControl";
import {PageLoader} from "../../../../../public/js/extras/PageLoader";

PageLoader.initializePresenterPage(true);
ControlsWelcomeRegisterRegisterControl.Loader.load();
